import {
  getWidgetSettingsStorage,
  setWidgetSettingsStorage
} from '@scripttag/helpers/sessionHelpers';
import {isFunction} from '../isFunction';

/**
 * @param currentPage
 * @returns {boolean}
 */
function checkIsEnableCurrentPage(currentPage) {
  const {widgetSetting: settings} = window.AVADA_FAQ;

  if (!currentPage || !settings) return false;

  switch (currentPage) {
    case 'chatDetail':
      return (
        settings.isEnableNewsletterPopup || settings.isLiveChat || settings.isEnableQuickReplies
      );
    case 'trackTab':
      return settings.isOrderTracking;
    case 'categoriesList':
    case 'questionDetail':
    case 'categoryDetail':
      return settings.isFeaturedArticles || settings.isCategory;
    default:
      return true;
  }
}

export const getDefaultState = (defaultData, key, isPreview) => {
  if (isPreview) return defaultData;
  const widgetPageSettings = getWidgetSettingsStorage();
  return (
    (checkIsEnableCurrentPage(widgetPageSettings.currentPage) && widgetPageSettings[key]) ||
    defaultData
  );
};

export const handleTriggerState = ({cb, prev, key, setState}) => {
  const result = isFunction(cb) ? cb(prev) : cb;
  setWidgetSettingsStorage({[key]: result});
  setState(result);
};
